"use client";

import React, { useEffect, useState } from "react";

declare global {
  var __API_BASE_URL: string | undefined;
  var __MAP_DOWNLOAD_FOLDER_LINK: string | undefined;
}

export function ConfigLoader({ children }: { children: React.ReactNode }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    fetch("/api/config")
      .then((res) => res.json())
      .then((data: { apiBaseUrl?: string; mapDownloadFolderLink?: string }) => {
        if (data.apiBaseUrl) globalThis.__API_BASE_URL = data.apiBaseUrl;
        if (data.mapDownloadFolderLink) {
          globalThis.__MAP_DOWNLOAD_FOLDER_LINK = data.mapDownloadFolderLink;
        }
        setReady(true);
      })
      .catch(() => setReady(true));
  }, []);

  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-gray-300 border-t-gray-600" />
      </div>
    );
  }
  return <>{children}</>;
}
